import { ResponseError } from '@websolutespa/payload-utils/server';

export const errorHandler = (error: any, init?: ResponseInit) => {
  return ResponseError(error, init);
  /*
  const status = error && error.status ? error.status : 500;
  const message = error && error.message ? error.message : 'Unknown error';
  const exception = {
    ...(typeof error === 'object' ? error : {}),
    status,
    message,
  };
  /*
  res.setHeader('x-msg-id', 'messageId');
  res.setHeader('x-thread-id', 'threadId');
  res.setHeader('Access-Control-Expose-Headers', '*');
  */
  // res.status(exception.status).send(exception);
};
